<template>
  <BGModal :shown="dialogShown"
           :title="$t('notification_record.title')">
    <template #content>
      <v-container class="notification-record-content pa-0" fluid>
        <RemotePaginatedList full-height
                             :filter-options="filterOptions"
                             :headers="headers"
                             multi-sort
                             data-url="hkiarace/admin/event/enrollment/notifications/"
                             data-key="notifications"
                             :extra-params="{enrollment_id: enrollmentId}"
                             :refresh-trigger.sync="innerRefreshTrigger"
                             v-bind="$attrs">
          <template #item.create_at="{value}">
            {{ $parseDate(value) }}
          </template>
          <template #item.emails="{value}">
            <v-expansion-panels accordion v-if="value.length > 0">
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('notification_record.toggle_email_details') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col>
                      <v-text-field :label="$t('notification_record.email_subject')"
                                    readonly
                                    :value="value.slice(-1)[0].subject"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <v-input>
                        <v-container fluid class="flex-column pa-0">
                          <legend class="v-label theme--light">{{ $t('notification_record.email_content') }}</legend>
                          <v-card v-html="value.slice(-1)[0].content"></v-card>
                        </v-container>
                      </v-input>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template #item.push_notifications="{value}">
            <v-container v-if="value.length > 0">
              <v-row>
                <v-col>
                  <v-text-field outlined
                                readonly
                                dense
                                hide-details
                                :value="value.slice(-1)[0].content"></v-text-field>
                </v-col>
              </v-row>
            </v-container>

          </template>
        </RemotePaginatedList>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </template>

  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'EnrollmentNotificationRecordModal',
  components: {RemotePaginatedList, BGModal},
  props: {
    shown: Boolean,
    enrollmentId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          innerRefreshTrigger.value = true;
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Filter
    const filterOptions = ref([])

    // Data Table
    const headers = ref([
      {text: root.$t('notification_record.create_at'), value: 'create_at'},
      {text: root.$t('notification_record.template'), value: 'template.name'},
      {text: root.$t('notification_record.type'), value: 'type'},
      {text: root.$t('notification_record.email'), value: 'emails', sortable: false},
      {text: root.$t('notification_record.push_notification'), value: 'push_notifications', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    return {
      dialogShown,
      cancel,

      filterOptions,
      headers,
      innerRefreshTrigger,
    }
  }
}
</script>

<style lang="less">
.notification-record-content {
  display: flex;
  height: 100%;
}
</style>
